<mat-form-field appearance="outline">
  <mat-label>{{ label }}</mat-label>

  <mat-chip-grid #chipGrid>
    <!-- Render selected filters as chips -->
    @for (group of selectedADGroups; track group) {
      <mat-chip-row
        (removed)="removeADGroup(group)">
        <span class="chip-value">{{ group?.group}}</span>
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip-row>
    }

    <!-- Input field for new filters -->
    <input
      matInput
      [formControl]="filterControl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipGrid"
      (matChipInputTokenEnd)="addFreeTextFilter($event)"
      (keydown.enter)="handleEnterKey($event)"
      placeholder="Search"
      appearance="fill"
      />
      <button mat-icon-button matSuffix (click)="filterControl.setValue('')"><mat-icon>clear</mat-icon></button>
    </mat-chip-grid>

    <!-- Autocomplete for chip names -->
    <mat-autocomplete #auto (optionSelected)="selectADGroup($event)" autoActiveFirstOption>
      @for (group of options | async; track group) {
        <mat-option [value]="group">
          {{ group.group }}
        </mat-option>
      }
    </mat-autocomplete>

    <mat-hint>{{ hint }}</mat-hint>
  </mat-form-field>
